/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 91);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(18)('wks')
  , uid        = __webpack_require__(15)
  , Symbol     = __webpack_require__(0).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(7)
  , createDesc = __webpack_require__(16);
module.exports = __webpack_require__(4) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(14)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(34)
  , defined = __webpack_require__(11);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(8)
  , IE8_DOM_DEFINE = __webpack_require__(31)
  , toPrimitive    = __webpack_require__(28)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(4) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(18)('keys')
  , uid    = __webpack_require__(15);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(30)
  , enumBugKeys = __webpack_require__(19);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(7).f
  , has = __webpack_require__(3)
  , TAG = __webpack_require__(1)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(0)
  , core      = __webpack_require__(5)
  , ctx       = __webpack_require__(38)
  , hide      = __webpack_require__(2)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10)
  , document = __webpack_require__(0).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(29)
  , $export        = __webpack_require__(22)
  , redefine       = __webpack_require__(32)
  , hide           = __webpack_require__(2)
  , has            = __webpack_require__(3)
  , Iterators      = __webpack_require__(9)
  , $iterCreate    = __webpack_require__(42)
  , setToStringTag = __webpack_require__(20)
  , getPrototypeOf = __webpack_require__(45)
  , ITERATOR       = __webpack_require__(1)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offersWidget = exports.cachedTextOffers = exports.cachedImgsOffers = undefined;

var _getIterator2 = __webpack_require__(50);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _langs = __webpack_require__(26);

var _langs2 = _interopRequireDefault(_langs);

var _showMethods = __webpack_require__(55);

var _imgs = __webpack_require__(56);

var _validateOpts = __webpack_require__(57);

var _text = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cachedImgsOffers = exports.cachedImgsOffers = [];
var cachedTextOffers = exports.cachedTextOffers = [];

var offersWidget = exports.offersWidget = function offersWidget() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$url = _ref.url,
      url = _ref$url === undefined ? 'https://www.studentagency.cz/shared/wc/airticket-offers-widget/data.json?id=letenky.cz' : _ref$url,
      _ref$target = _ref.target,
      target = _ref$target === undefined ? '#offers-widget > .container' : _ref$target,
      _ref$showOffersBaseIn = _ref.showOffersBaseInterval,
      showOffersBaseInterval = _ref$showOffersBaseIn === undefined ? 70 : _ref$showOffersBaseIn,
      _ref$showOffersInterv = _ref.showOffersInterval,
      showOffersInterval = _ref$showOffersInterv === undefined ? 70 : _ref$showOffersInterv,
      _ref$showMethod = _ref.showMethod,
      showMethod = _ref$showMethod === undefined ? 'linear' : _ref$showMethod,
      _ref$iframeAddress = _ref.iframeAddress,
      iframeAddress = _ref$iframeAddress === undefined ? "" : _ref$iframeAddress,
      _ref$randomize = _ref.randomize,
      randomize = _ref$randomize === undefined ? false : _ref$randomize,
      _ref$offers = _ref.offers,
      offers = _ref$offers === undefined ? {
    imgs: [{ name: 'offer', type: 'big' }, { name: 'offer', type: 'small' }, { name: 'offer', type: 'small' }, { name: 'offer', type: 'small' }, { name: 'offer', type: 'small' }, { name: 'map', type: 'small' }, { name: 'offer', type: 'small' }],
    text: [{ name: 'offer', type: 'small' }, { name: 'offer', type: 'small' }, { name: 'offer', type: 'small' }, { name: 'offer', type: 'small' }]
  } : _ref$offers;

  var opts = {
    url: url,
    target: target,
    showOffersBaseInterval: showOffersBaseInterval,
    showOffersInterval: showOffersInterval,
    showMethod: showMethod,
    offers: offers,
    randomize: randomize
  };

  var imgs = offers.imgs,
      text = offers.text;


  init();

  function init() {
    if (!(0, _validateOpts.validateOpts)(opts)) return;

    if (typeof imgs !== 'undefined' && imgs.length > 0) {
      var imgsBlock = '<div class="imgs-offers-block row"><ul>';

      imgs.map(function (item) {
        return imgsBlock += (0, _imgs.offerImgTemplate)(item);
      });
      imgsBlock += '</ul></div>';
      $(imgsBlock).appendTo(target);
    }

    if (typeof text !== 'undefined' && text.length > 0) {
      var textBlock = '<div class="text-offers-block row"><ul>';

      text.map(function (item) {
        return textBlock += (0, _text.offerTextTemplate)(item);
      });
      textBlock += '</ul></div>';
      $(textBlock).appendTo(target);
    }

    getData();
  }

  function getData() {
    var totalItems = 0;
    if (typeof imgs !== 'undefined') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(imgs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.name === 'offer') totalItems++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    if (typeof text !== 'undefined') {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(text), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _item = _step2.value;

          if (_item.name === 'offer') totalItems++;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    if (randomize) {
      totalItems = 10;
    }

    $.getJSON(url + '&count=' + totalItems).then(function (json) {
      var data = json.data,
          options = json.options;

      var item = void 0,
          decrementIndex = false,
          lastIndex = void 0;
      var counter = 0;
      var loadedImgs = 0;
      var shuffledData = [];

      if (randomize) {
        shuffledData = shuffle(data);
        shuffledData.sort(function (a, b) {
          return parseFloat(a.total) - parseFloat(b.total);
        });
      } else {
        shuffledData = data;
      }

      cachedImgsOffers.map(function (item, index) {
        if (counter !== data.length) {
          if (decrementIndex) {
            decrementIndex = false;
            index--;
          }

          var route = shuffledData[index];

          switch (item.name) {
            case 'offer':
              var img = new Image();
              counter++;
              // pokud dany obrazek k nabidce existuje ${iata}-small/big.jpg
              img.onload = function () {
                item = (0, _imgs.offerImgContent)(route, _langs2.default[route.type], route.journeys[0]['to-iata'] + '-' + item.type);

                $(item).appendTo($('#offers-widget .imgs-offers-block .offer:eq(' + index + ')')).parent().addClass('test');

                loadedImgs++;
              };
              // pokud obrazek k nabidce neexistuje - default-offer-small/big.jpg
              img.onerror = function () {
                item = (0, _imgs.offerImgContent)(route, _langs2.default[route.type], 'default-offer-' + item.type);

                $(item).appendTo($('#offers-widget .imgs-offers-block .offer:eq(' + index + ')')).parent().addClass('test');

                loadedImgs++;
              };

              img.src = '/sys/images/offers/' + route.journeys[0]['to-iata'] + '-' + item.type + '.jpg';

              break;
            case 'map':
              decrementIndex = true;
              item = (0, _imgs.mapContent)(iframeAddress);

              $(item).appendTo($('#offers-widget .imgs-offers-block .map')).parent().addClass('test');

              break;
          }

          lastIndex = index;
        }
      });

      // spocitani obrazkovych nabidek (bez mapy)
      var imgsOffers = 0;
      for (var i = 0; i < cachedImgsOffers.length; i++) {
        cachedImgsOffers[i].name === 'offer' ? imgsOffers++ : '';
      }
      // ceka se, az skript zkontroluje obrazky (loadedImgs)
      var timer = setInterval(function () {
        // pokud se pocet nactenych obrazku rovna zacahevoanym nabidkam,
        // nebo pokud se pocet nactenych obrazku rovna nebo je mensi nabidkam zikanych ze serveru
        // stavalo se totiz to, ze prichazely napr. jen 3 nabidky ze serveru a pote se nezobrazila ani jedna (loadedImgs se pote nerovnal imgsOffers)
        if (loadedImgs === imgsOffers || loadedImgs >= data.length) {
          clearInterval(timer);

          cachedTextOffers.map(function (item, index) {
            if (counter !== data.length) {
              lastIndex++;
              var route = data[lastIndex];

              if (typeof item.name === 'undefined') return;

              switch (item.name) {
                case 'offer':
                  item = (0, _text.offerTextContent)(route);
                  $(item).appendTo($('#offers-widget .text-offers-block .offer:eq(' + index + ')')).parent().addClass('test');

                  counter++;

                  break;
              }
            }
          });

          if (typeof _showMethods.showMethods[showMethod] === 'function' && typeof _showMethods.showMethods[showMethod] !== 'undefined') _showMethods.showMethods[showMethod](opts);
        }
      }, 10);
    }).fail(function (err) {
      console.error('Error loading data', err);
    });
  }

  function shuffle(array) {
    var currentIndex = array.length,
        temporaryValue,
        randomIndex;

    while (0 !== currentIndex) {

      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array.slice(0, 4);
  }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ROUND_TRIP: 'letenka tam i zpět',
  ONE_WAY: 'jednosměrná letenka',
  OPEN_JAW: 'letenka s přestupem',
  ACTION_MAP: 'Mapa akčních letenek',
  CURRENCY: 'CZK',
  FROM: 'od'
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(11);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(10);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(3)
  , toIObject    = __webpack_require__(6)
  , arrayIndexOf = __webpack_require__(35)(false)
  , IE_PROTO     = __webpack_require__(13)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(4) && !__webpack_require__(14)(function(){
  return Object.defineProperty(__webpack_require__(23)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(8)
  , dPs         = __webpack_require__(43)
  , enumBugKeys = __webpack_require__(19)
  , IE_PROTO    = __webpack_require__(13)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(23)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(44).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(21);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(6)
  , toLength  = __webpack_require__(36)
  , toIndex   = __webpack_require__(37);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(12)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(12)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(39);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(41)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(24)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(12)
  , defined   = __webpack_require__(11);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(33)
  , descriptor     = __webpack_require__(16)
  , setToStringTag = __webpack_require__(20)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(2)(IteratorPrototype, __webpack_require__(1)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(7)
  , anObject = __webpack_require__(8)
  , getKeys  = __webpack_require__(17);

module.exports = __webpack_require__(4) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0).document && document.documentElement;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(3)
  , toObject    = __webpack_require__(27)
  , IE_PROTO    = __webpack_require__(13)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47);
var global        = __webpack_require__(0)
  , hide          = __webpack_require__(2)
  , Iterators     = __webpack_require__(9)
  , TO_STRING_TAG = __webpack_require__(1)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(48)
  , step             = __webpack_require__(49)
  , Iterators        = __webpack_require__(9)
  , toIObject        = __webpack_require__(6);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(24)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(51), __esModule: true };

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(40);
module.exports = __webpack_require__(52);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8)
  , get      = __webpack_require__(53);
module.exports = __webpack_require__(5).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(54)
  , ITERATOR  = __webpack_require__(1)('iterator')
  , Iterators = __webpack_require__(9);
module.exports = __webpack_require__(5).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(21)
  , TAG = __webpack_require__(1)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var showMethods = exports.showMethods = {
  random: function random(opts) {
    var interval = opts.showOffersBaseInterval;
    var plusInterval = opts.showOffersInterval;
    var counter = 0;
    var offersContents = $('#offers-widget .content');
    var total = offersContents.length;

    for (var i = 0; i < total; i++) {
      var timer = setTimeout(function () {
        var index = Math.ceil(Math.random() * offersContents.length) - 1;
        var currentItem = $(offersContents[index]);
        currentItem.addClass('show-content');

        offersContents.splice($.inArray(offersContents[index], offersContents), 1);

        //zakryti preloaeru, az jsou nabidky nacteny
        counter++;
        if (counter == offersContents.length) setTimeout(function () {
          $('#offers-widget').addClass('hide-preloader-bg');
        }, 1000); // ms CSS transition
      }, interval);

      interval += plusInterval;
    }
  },
  linear: function linear(opts) {
    var interval = opts.showOffersBaseInterval;
    var plusInterval = opts.showOffersInterval;
    var counter = 0;
    var offersContents = $('#offers-widget .item');
    // let offersContents = $(`#offers-widget .content`)

    offersContents.each(function (index, item) {
      var timer = setTimeout(function () {
        if (!$(item).hasClass('test')) {
          $(item).css({
            transition: '1s all',
            opacity: 0,
            visibility: 'hidden'
          });
        }

        $(item).find('.content').addClass('show-content');

        //zakryti preloaeru, az jsou nabidky nacteny
        counter++;
        if (counter == offersContents.length) setTimeout(function () {
          $('#offers-widget').addClass('hide-preloader-bg');
        }, 1000); // ms CSS transition
      }, interval);

      interval += plusInterval;
    });
  }
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapContent = exports.offerImgContent = exports.offerImgTemplate = undefined;

var _langs = __webpack_require__(26);

var _langs2 = _interopRequireDefault(_langs);

var _main = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var grayscaleLogo = 'data:image/png;base64,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';
var offerImgTemplate = exports.offerImgTemplate = function offerImgTemplate(opts) {
  var item = '<li class="item ' + opts.name + ' ' + (opts.type === 'big' ? 'big col-xxs-12 col-xs-6 col-sm-8 col-lg-6 ' : 'small col-xxs-12 col-xs-6 col-sm-4 col-lg-3') + '">\n                <div class="preloader-bg bg-' + Math.ceil(Math.random() * 2) + '">\n                  <img class="preloader-logo" src=' + grayscaleLogo + ' alt="letenky.cz">\n                  <div class="offer-overlay">';

  var total = opts.type === 'big' ? 12 : 9;
  for (var i = 1; i <= total; i++) {
    item += '<div class="offer-overlay-' + i + ' ' + (i === 1 ? '' : 'stripe') + '"></div>';
  }

  // ending
  item += '</div></div></li>';

  _main.cachedImgsOffers.push({ name: opts.name, type: opts.type });

  return item;
};

var offerImgContent = exports.offerImgContent = function offerImgContent(route, routeType, imgName) {
  var name = route.journeys[0]['to-name'];
  // let iata = route.journeys[0]['to-iata']

  return '<a href="' + route.url + '" class="content">\n            <div class="content-bg" style="background-image: url(\'/sys/images/offers/' + imgName + '.jpg\')"></div>\n            <div class="content-text">\n              <strong class="name">' + name + '</strong>\n              <strong class="price">' + _langs2.default.FROM + ' ' + formatePrice(route.total) + '&nbsp;' + _langs2.default.CURRENCY + '</strong>\n              <strong class="desc">' + routeType + '</strong>\n            </div>\n          </a>';
};

var mapContent = exports.mapContent = function mapContent(route) {
  if (route === " ") {
    return '<a href="/mapa-akcnich-letenek/" class="content">\n              <div class="content-bg"></div>\n              <div class="content-text">\n                <i class="sa-icon icon-letadlo"></i>\n                <strong>' + _langs2.default.ACTION_MAP + '</strong>\n              </div>\n            </a>';
  } else {
    return '<a class="content" href=\'http://brn-ads.sa.cz/www/delivery/ck.php?n=a1d0d412&cb=INSERT_RANDOM_NUMBER_HERE\' target=\'_blank\'><iframe src=\'/shared/ads/ad.jsp??cb=INSERT_RANDOM_NUMBER_HERE&zoneid=389\' frameborder=\'0\' scrolling=\'no\' width=\'263\' height=\'263\'></iframe></a>'; //<img src='https://brn-ads.sa.cz/www/delivery/avw.php?zoneid=389&cb=INSERT_RANDOM_NUMBER_HERE&n=a1d0d412' border='0' alt='' />
  }
};

function formatePrice(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var validateOpts = exports.validateOpts = function validateOpts(opts) {
  var _opts$offers = opts.offers,
      imgs = _opts$offers.imgs,
      text = _opts$offers.text;

  if (imgs.length === 0 && text.length === 0) {
    console.log('Chyba v opts, musi byt zadany alespon nejake offery!');
    return false;
  }

  if (typeof opts.url !== 'string' || typeof opts.url === 'undefined') {
    console.log('Chyba v opts - url!');
    return false;
  }

  if (typeof opts.target !== 'string' || typeof opts.target === 'undefined') {
    console.log('Chyba v opts - target!');
    return false;
  }

  return true;
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offerTextContent = exports.offerTextTemplate = undefined;

var _langs = __webpack_require__(26);

var _langs2 = _interopRequireDefault(_langs);

var _main = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var offerTextTemplate = exports.offerTextTemplate = function offerTextTemplate(opts) {
  var item = '<li class="item ' + opts.name + ' ' + (opts.type === 'big' ? 'big col-xxs-12 col-xs-6 col-lg-3' : 'small col-xxs-12 col-xs-6 col-lg-3') + '">\n                <div class="preloader-bg bg-' + Math.ceil(Math.random() * 2) + '">\n                  <div class="offer-overlay">\n                    <div class="offer-overlay-1 stripe"></div>\n                    <div class="offer-overlay-2 stripe"></div>\n                    <div class="offer-overlay-3 stripe"></div>\n                    <div class="offer-overlay-4 stripe"></div>\n                    <div class="offer-overlay-5 stripe"></div>\n                  </div>\n                </div>\n              </li>';

  _main.cachedTextOffers.push({ name: opts.name });

  return item;
};

var offerTextContent = exports.offerTextContent = function offerTextContent(route) {
  var fromName = route.journeys[0]['from-name'];
  var toName = route.journeys[0]['to-name'];

  return '<a href="' + route.url + '" class="content">\n            <div class="content-text clearfix">\n              <strong class="name">\n                <span class="from-name">' + fromName + '</span>\n                <span class="delimeter">&nbsp;-&nbsp;</span>\n                <span class="to-name">' + toName + '</span>\n              </strong>\n              <strong class="price">' + formatePrice(route.total) + '&nbsp;' + _langs2.default.CURRENCY + '</strong>\n            </div>\n          </a>';
};

function formatePrice(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(60), __esModule: true };

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61);
module.exports = __webpack_require__(5).Object.keys;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(27)
  , $keys    = __webpack_require__(17);

__webpack_require__(62)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(22)
  , core    = __webpack_require__(5)
  , fails   = __webpack_require__(14);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(92);


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slider = __webpack_require__(93);

var _main = __webpack_require__(25);

__webpack_require__(98);

(function () {
  var FormTabsEngine = __webpack_require__(99);
  var PreparePostInit = __webpack_require__(101);

  var hpFormsOptions = __webpack_require__(102)();

  hpFormsOptions = PreparePostInit(hpFormsOptions, []);

  var affiliatePath = '/.config/hp-forms-affiliates/';

  var hpForms = new FormTabsEngine({
    'form-1': ['airticketFormSmall', hpFormsOptions.letenky],
    'form-2': affiliatePath + 'bookingHpForm',
    'form-3': affiliatePath + 'rentalCarHpForm',
    'form-4': ['insuranceForm', hpFormsOptions.pojisteni]
  });

  (0, _main.offersWidget)();

  (0, _slider.slider)();

  // Inicializace prvního formuláře
  hpForms.init('form-1');
})();

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slider = undefined;

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slider = exports.slider = function slider() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$initialItem = _ref.initialItem,
      initialItem = _ref$initialItem === undefined ? 0 : _ref$initialItem,
      _ref$selector = _ref.selector,
      selector = _ref$selector === undefined ? '#hp-slider' : _ref$selector,
      _ref$transitionSpeed = _ref.transitionSpeed,
      transitionSpeed = _ref$transitionSpeed === undefined ? 1000 : _ref$transitionSpeed,
      _ref$delayTime = _ref.delayTime,
      delayTime = _ref$delayTime === undefined ? 5000 : _ref$delayTime;

  var opts = {
    initialItem: initialItem,
    selector: selector,
    transitionSpeed: transitionSpeed,
    delayTime: delayTime
  };

  var timer = void 0;
  var slider = $(opts.selector);
  var items = slider.find('> ul > li');
  var itemsLength = items.length;
  var currentItem = opts.initialItem;
  var controls = $('.slider-controls');
  var activatedItems = [];

  init();

  function init() {
    // pokud je jen jeden item, tak se slider vubec nebude spoustet
    if (itemsLength <= 1) return;

    showControls();
    // transition: cubic-bezier(0.25, 0.74, 0.57, 1.01);
    // -webkit-transition-timing-function: cubic-bezier(0.25, 0.74, 0.57, 1.01);
    // transition: 1s;

    slider.removeClass('no-js-slider');
    items.css((0, _defineProperty3.default)({
      'transition': 'cubic-bezier(0.38, 0.19, 0.36, 1)',
      '-webkit-transition-timing-function': 'cubic-bezier(0.38, 0.19, 0.36, 1)'
    }, 'transition', opts.transitionSpeed + 'ms all'));
    // items.css({
    //   'transition': `${opts.transitionSpeed}ms all`
    // })
    activateItem(slider.find('li:eq(' + opts.initialItem + ')'));
    // slider.find(`li:eq(${opts.initialItem})`).addClass('active')
    changeInInterval();

    // checkSliderOnResize(window.innerWidth)
    // $(window).on('resize', () => {
    //   checkSliderOnResize(window.innerWidth)
    // })

    // zastaveni prokliku kdyz je xxs
    // items.find('a').on('click', function(e) {
    //   if(window.innerWidth <= 480)
    //     e.preventDefault()
    // })
  }

  function activateItem(item) {
    if (activatedItems.indexOf(currentItem) <= -1) {
      var src = item.attr('data-src');
      item.find('img').attr('src', src);
      item.addClass('active');
      activatedItems.push(currentItem);
    } else {
      item.addClass('active');
    }
    // $("<img/>")
    // .on('load', () => {
    //   console.log("image loaded correctly")
    // })
    // .on('error', () => {
    //   console.log("error loading image");
    // })
    // .attr("src", src)
  }

  function checkSliderOnResize(winWidth) {
    // mene nebo rovno nez xxs (xxs = 480px) tak zrusime animaci slideru, protoze to pusobi dost rusive na mobilu
    if (winWidth <= 480) stopInterval();
    // a kdyz neni xxs, tak ji znovu rozjedeme na plny pecky, at se z toho ty lidi poserou poradne
    else resetInterval();
  }

  function stopInterval() {
    clearInterval(timer);
  }

  function showControls() {
    controls.addClass('show');
  }

  function hideControls() {
    controls.addClass('hide');
  }

  function changeInInterval() {
    timer = setInterval(function () {
      moveNext();
    }, opts.delayTime);
  }

  function resetInterval() {
    clearInterval(timer);
    changeInInterval();
  }

  function moveNext() {
    resetInterval();
    if (++currentItem === itemsLength) currentItem = 0;

    items.removeClass('active');
    activateItem(slider.find('li:eq(' + currentItem + ')'));
    // slider.find(`li:eq(${currentItem})`).addClass('active')
  }

  function moveBack() {
    resetInterval();
    if (--currentItem === -1) currentItem = itemsLength - 1;

    items.removeClass('active');
    activateItem(slider.find('li:eq(' + currentItem + ')'));
    // slider.find(`li:eq(${currentItem})`).addClass('active')
  }

  slider.find('.back').on('click', function () {
    return moveBack();
  });

  slider.find('.next').on('click', function () {
    return moveNext();
  });
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(95);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(96), __esModule: true };

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97);
var $Object = __webpack_require__(5).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(22);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(4), 'Object', {defineProperty: __webpack_require__(7).f});

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(100);

module.exports = function FormTabsEngine(config) {

  if (!$.isPlainObject(config)) return new Error('Parametr config musí být objekt');

  var loadedForms = [];
  var forms = {};
  var formTabsButton = $('.nav-tabs li');

  this.init = loadFormIntoTab;

  formTabsButton.click(handleTabClick);

  for (var key in config) {

    var value = config[key];
    var elemId = '#' + key;

    if (typeof value === 'string') forms[key] = helpers.prepareHtmlLoad(elemId, value);

    if ($.isArray(value) && $.isFunction($(elemId)[value[0]])) forms[key] = helpers.prepareWidget(elemId, value[0], value[1] || {});
  }

  if (window.location.hash) {
    handleTabClick(null, window.location.hash);
  }

  function handleTabClick(e) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var formId = id != null ? id.replace('#', '') : $(this).attr('aria-controls');
    var scrollmem = $('html,body').scrollTop();

    if (formId !== 'form-2') window.location.hash = '#' + formId;

    $('html,body').scrollTop(scrollmem);

    var form = $('#' + formId);

    if (formId === 'form-2') {
      //window.location = 'http://ubytovani.letenky.cz/'
      $('#hp-form-tabs > .tab-content').append("<div id='b_container'></div>");
    }

    loadFormIntoTab(formId);

    handleLoader(form);
  }

  function loadFormIntoTab(formId) {
    if (loadedForms.indexOf(formId) < 0 && $.isFunction(forms[formId])) forms[formId]();

    loadedForms.push(formId);
  }

  // handle na loader - odkryti loaderu po kliku, skryti loaderu na ubytovani a pronajmu aut, az je iframe nacteny
  function handleLoader(form) {
    var formId = form.attr('id');
    var loader = form.find('.loader');

    loader.show();

    if (formId == 'form-2' || formId == 'form-3') {
      var checker = setInterval(function () {
        if (form.find('iframe').is(':visible')) {
          loader.hide();
          clearInterval(checker);
        }
      }, 10);
    }
  }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  // nacte data z dane cesty (zadane v index.js v hpForms)
  prepareHtmlLoad: function prepareHtmlLoad(elemId, url) {
    return function () {
      $.get(url, function (data) {
        return $(elemId).html(data);
      });
    };
  },


  // nacte widget z komponent
  prepareWidget: function prepareWidget(elemId, widget, options) {
    return function () {
      $(elemId)[widget](options);
    };
  }
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(59);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function preparePostInitFunction(options, instead) {

  // presunuti blokyu poslednich vyhledavani nakonec pod submit
  window.ybusPostRenderFunction = function (self) {
    $(self.find('.form-submit')).after(self.find('#ybus-saved_routes-block'));
  };

  function sharedFunction(component, context) {
    if (!Modernizr.touch) {

      context.find('select').each(function () {
        //Označovanie vybraného prvku v selectu robilo problémy
        //Vyberiem hodnotu označeného optionu (s atribútom selected)
        var selectedValue = $(this).find('option[selected="selected"]').val();
        var sel = new Select({
          el: this,
          alignToHighlighted: 'always'
        });

        //Zmením hodnotu nového selectu podľa predtým uloženej
        if (selectedValue) sel.change(selectedValue);
      });

      //Natvrdo intervalu označím prvý option. Označoval sa tretí
      var int_option = $('#search_interval option[selected="selected"]');
      if (int_option) int_option.attr("selected", true);
    } else {
      context.find('select').each(function () {
        $(this).selectTouch();
      });
    }
  }

  // postInitHook funkce pro letenky
  function letenky(component, context) {
    var opts = context.data('opts');

    // presun ulozenych cest pod submit
    $('.' + opts.name + ' .form-submit').after($('.' + opts.name + ' #airticket-saved_routes-block'));

    sharedFunction(component, context);

    window.airSelectPostRenderFunction = function () {
      sharedFunction(null, $('#airticket-airline-block'));
    };

    function getIntervalSelect() {
      var instance = null;
      $('#form-1').find('select#search_interval').each(function () {
        instance = this.selectInstance;
      });
      return instance;
    }

    //WEB-3369 defaultné hodnoty intervalu
    window.airticketActivateFormCustom = {
      oneway: function oneway() {
        var instance = getIntervalSelect();
        if (instance) instance.change(String($('#oneway').data('search_interval')));
      },
      round_trip: function round_trip() {
        var instance = getIntervalSelect();
        if (instance) instance.change(String($('#round_trip').data('search_interval')));
      },
      open_jaw: function open_jaw() {
        var instance = getIntervalSelect();
        if (instance) instance.change(String($('#open_jaw').data('search_interval')));
      }
    };
  }

  // sestaveni objektu s postInitFunkci
  var postInit = {
    letenky: {
      postInitHook: letenky
    },
    jizdenky: {
      postInitHook: sharedFunction
    },
    ubytovani: {
      postInitHook: sharedFunction
    },
    pojisteni: {
      postInitHook: sharedFunction
    },
    auta: {
      postInitHook: sharedFunction
    },
    jazykovePobyty: {
      postInitHook: sharedFunction
    },
    pracovniPobyty: {
      postInitHook: sharedFunction
    },
    dovolena: {
      postInitHook: sharedFunction
    }
  };

  (0, _keys2.default)(options).forEach(function (key) {
    if (instead.length !== 0) {
      if (jQuery.inArray(key, instead) !== 0) options[key] = $.extend({}, options[key], postInit[key]);
    } else {
      options[key] = $.extend({}, options[key], postInit[key]);
    }
  });

  return options;
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(59);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function () {
  var sharedOptions = {
    id: 'letenky.cz',
    hostname: '//olymp9.sa.cz/shared/'

  };
  var options = {
    letenky: {
      maxRoutes: 5,
      formType: 'round_trip'
    },
    pojisteni: {}
  };

  (0, _keys2.default)(options).forEach(function (key) {
    options[key] = $.extend({}, sharedOptions, options[key]);
  });

  return options;
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/homepage.js